import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import TopTicker from '@/pages/home/components/TopTicker';
import Hero from '@/pages/home/components/Hero';
import HotBoard from '@/pages/home/components/HotBoard';
import LatestFeed from '@/pages/home/components/LatestFeed';
import TrackingList from '@/pages/home/components/TrackingList';
import HotSearchPanel from '@/pages/home/components/HotSearchPanel';
import CollectionGrid from '@/pages/home/components/CollectionGrid';
import CommunityBuzz from '@/pages/home/components/CommunityBuzz';
import SubmitCta from '@/pages/home/components/SubmitCta';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <TopTicker />
      <SiteHeader />

      <main className="flex-1">
        <Hero />
        <HotBoard />

        <section className="w-full px-4 py-14 md:px-6 md:py-20">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-3 lg:gap-12">
            <div className="lg:col-span-2">
              <LatestFeed />
            </div>
            <aside className="space-y-6 lg:col-span-1">
              <TrackingList />
              <HotSearchPanel />
            </aside>
          </div>
        </section>

        <CollectionGrid />

        <section className="w-full px-4 py-14 md:px-6 md:py-20">
          <CommunityBuzz />
        </section>

        <SubmitCta />
      </main>

      <SiteFooter />
    </div>
  );
}